module.exports = __webpack_public_path__ + "src/views/player/lc/music.mp3";